import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

const uploadBarSectionTemplate = htmlE`
        ${({
          hideDNDUploadInfoText,
          addFilesText,
          dragAndDropFileAndFoldersHereToUploadText,
        }) => {
          return `<div id="uploadBarSection" class="p-2">
          <input id="fileInputGlobal" multiple class="is-hidden" type="file" />
          <button id="globalAddFilesButton" class="primary-button text-sm is-bordered">
            <i class="icon-upload mr-2 text-accentMain"></i>
            <span data-i18n-key="addFiles">${addFilesText}</span>
          </button>
          <div class="is-flex is-justify-content-center is-align-items-center">
            ${
              !hideDNDUploadInfoText
                ? `<p data-i18n-key="dragAndDropFileAndFoldersHereToUpload" data-i18n-defaultValue="Drag & Drop Files and Folders Here To Upload" class="text-sm">${dragAndDropFileAndFoldersHereToUploadText}</p>`
                : ""
            }
          </div>
          <div></div>
        </div>`;
        }}
`;

export default uploadBarSectionTemplate;
